/* Mobile menu "Search" link opens the search bar (adds "search-bar-open" to
   <body>, via theme.js's searchFormOpen) but never closes the mobile nav
   drawer - the drawer is a full-screen overlay with a far higher z-index
   than the search bar, so it stays covering the screen and the search
   input never becomes visible. Close the drawer whenever Search is clicked
   from inside it, so the search bar underneath is revealed.
   theme.js's own searchFormOpen handler calls evt.stopPropagation(), which
   would block a same-phase (bubble) listener bound above it (e.g. on
   document) from ever running - so this listens on the *capture* phase
   instead, which always runs regardless of any later stopPropagation()
   during bubbling. */
(function ($) {
  if (!$) return;

  document.addEventListener('click', function (evt) {
    var searchLink = evt.target.closest('.mobile-site-nav .js-search-form-open');
    if (!searchLink) return;

    $('.header-navigation').removeClass('header-navigation--open');
    $(document.body).removeClass('mobile-menu-open');
  }, true);
})(window.jQuery);

/* Shopify's own preview bar (shown only to staff viewing a draft theme via
   ?preview_theme_id=, never on the live site) renders in the browser's
   native "popover" top layer - by design, that always paints above
   *everything* else on the page, including our fixed mobile add-to-cart
   bar (assets/custom-theme-fixes.css), regardless of z-index or DOM
   nesting. No CSS can out-rank it - confirmed by testing z-index:2147483647
   plus raising every ancestor's own z-index, neither worked. The preview
   bar itself offers a "Hide bar" control for this, but dismiss it
   automatically on mobile instead so reviewers see the real page (and the
   sticky Add to Cart bar) without an extra step. Uses the standard
   HTMLElement.hidePopover() API, so this only ever does anything when
   Shopify's preview bar element is actually present - inert everywhere
   else, including the published site.
   Shopify shows the bar asynchronously (confirmed by testing: sometimes
   it's already open by the time this deferred script runs, sometimes it
   opens later), so this both hides it immediately if already open *and*
   listens for the popover's own "toggle" event to catch it opening after
   the fact - covers both orderings without relying on a fixed delay. */
(function () {
  if (window.matchMedia('(min-width: 768px)').matches) return;

  var previewBar = document.getElementById('PBarNextFrameWrapper');
  if (!previewBar || !previewBar.hidePopover) return;

  if (previewBar.matches(':popover-open')) {
    previewBar.hidePopover();
  }

  previewBar.addEventListener('toggle', function (evt) {
    if (evt.newState === 'open') {
      previewBar.hidePopover();
    }
  });
})();
